module.exports = __webpack_public_path__ + "static/media/information.edafc0a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/information.svg
// module id = 610
// module chunks = 1